/* Lash It Out sticky add to bag.
   Clones the real product button so Ella's own cart logic still runs. */
(function () {
  'use strict';

  function init() {
    try {
      if (!document.body.classList.contains('template-product')) return;

      var main = document.getElementById('MainContent');
      if (!main) return;

      var form = main.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var realBtn = form.querySelector('button[name="add"], [type="submit"]');
      if (!realBtn) return;

      var titleEl = main.querySelector('.product__title, .product-title, h1');
      var title = titleEl ? titleEl.textContent.trim() : '';
      if (!title) return;

      var bar = document.createElement('div');
      bar.className = 'lio-sticky-atc';
      bar.innerHTML =
        '<div class="lio-sticky-atc__inner">' +
          '<div class="lio-sticky-atc__info">' +
            '<span class="lio-sticky-atc__title"></span>' +
            '<span class="lio-sticky-atc__price"></span>' +
          '</div>' +
          '<button class="lio-sticky-atc__btn" type="button"></button>' +
        '</div>';

      bar.querySelector('.lio-sticky-atc__title').textContent = title;
      document.body.appendChild(bar);

      var barBtn = bar.querySelector('.lio-sticky-atc__btn');
      var priceOut = bar.querySelector('.lio-sticky-atc__price');

      function readPrice() {
        var el = main.querySelector('.price__sale .price-item--sale, .price-item--regular, .product__price, .price');
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
      }

      function sync() {
        try {
          barBtn.textContent = (realBtn.textContent || 'Add to bag').replace(/\s+/g, ' ').trim() || 'Add to bag';
          barBtn.disabled = !!realBtn.disabled;
          priceOut.textContent = readPrice();
        } catch (e) { /* leave the bar as it is */ }
      }

      sync();

      barBtn.addEventListener('click', function () {
        realBtn.click();
      });

      /* Keep label, price and availability in step with variant changes. */
      if (window.MutationObserver) {
        new MutationObserver(sync).observe(form, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'class']
        });
      }
      form.addEventListener('change', function () { setTimeout(sync, 150); });

      /* Sit above Ella's mobile toolbar if that is switched on. */
      var toolbar = document.querySelector('.halo-toolbar-mobile, .toolbar-mobile');
      if (toolbar && toolbar.offsetHeight > 0) {
        var pos = window.getComputedStyle(toolbar).position;
        if (pos === 'fixed') bar.style.bottom = toolbar.offsetHeight + 'px';
      }

      /* Show the bar only once the real button has scrolled away. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -60px 0px' }).observe(realBtn);
      } else {
        bar.classList.add('is-visible');
      }
    } catch (e) { /* never block the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
